export const CompanyFields = {
  companyName: 'companyName',
  description: 'description',
  accountOwner: 'accountOwner',
  customerMembers: 'customerMembers',
  health: 'companyHealth',
  stage: 'companyStage',
  annualizedRecurringRevenue: 'annualizedRecurringRevenue',
  champions: 'champions',
  nextRenewalDate: 'contractRenewalDate',
  overAllProjectRating: 'csatRating',
  lastMilestoneCSAT: 'lastMilestoneCSAT',
  joinedAt: 'createdAt',
  trackedHours: 'trackedMinutes',
  billableHours: 'billableMinutes',
  totalAllocatedHours: 'allocatedMins',
  actualRevenue: 'actualRevenue',
  estimatedRevenue: 'estimatedRevenue',
  actualProfit: 'actualProfit',
  estimatedProfit: 'estimatedProfit',
  actualProfitMargin: 'actualMargin',
  estimatedProfitMargin: 'estimatedMargin',
  actualCost: 'actualCost',
  estimatedCost: 'estimatedCost',
  companyNote: 'companyNote',
  lastActivityDate: 'lastActivityDate',
};

export const default_fields = [
  CompanyFields.companyName,
  CompanyFields.description,
  CompanyFields.accountOwner,
  CompanyFields.customerMembers,
  CompanyFields.annualizedRecurringRevenue,
  CompanyFields.champions,
  CompanyFields.nextRenewalDate,
  CompanyFields.overAllProjectRating,
  CompanyFields.lastMilestoneCSAT,
  CompanyFields.joinedAt,
  CompanyFields.lastActivityDate,
];
export const financial_fields = [
  CompanyFields.trackedHours,
  CompanyFields.billableHours,
  CompanyFields.totalAllocatedHours,
  CompanyFields.actualRevenue,
  CompanyFields.estimatedRevenue,
  CompanyFields.actualProfit,
  CompanyFields.estimatedProfit,
  CompanyFields.actualProfitMargin,
  CompanyFields.estimatedProfitMargin,
  CompanyFields.actualCost,
  CompanyFields.estimatedCost,
];
export const currency_fields = [
  CompanyFields.annualizedRecurringRevenue,
  CompanyFields.actualRevenue,
  CompanyFields.estimatedRevenue,
  CompanyFields.actualCost,
  CompanyFields.estimatedCost,
  CompanyFields.actualProfit,
  CompanyFields.estimatedProfit,
];
export const hours_fields = [
  CompanyFields.trackedHours,
  CompanyFields.totalAllocatedHours,
  CompanyFields.billableHours,
];
export const percentage_fields = [
  CompanyFields.actualProfitMargin,
  CompanyFields.estimatedProfitMargin,
];
export const rating_fields = [
  CompanyFields.overAllProjectRating,
  CompanyFields.lastMilestoneCSAT,
];
export const read_only_fields = [
  CompanyFields.joinedAt,
  CompanyFields.overAllProjectRating,
  CompanyFields.lastMilestoneCSAT,
  CompanyFields.trackedHours,
  CompanyFields.totalAllocatedHours,
  CompanyFields.billableHours,
  CompanyFields.actualRevenue,
  CompanyFields.estimatedRevenue,
  CompanyFields.actualProfit,
  CompanyFields.estimatedProfit,
  CompanyFields.actualProfitMargin,
  CompanyFields.estimatedProfitMargin,
  CompanyFields.actualCost,
  CompanyFields.estimatedCost,
];
